import React from 'react';

export default function ToastHost({ toast, onDismiss, COLORS }) {
  if (!toast?.message) return null;

  const palette = {
    success: {
      bg: `${COLORS.green}22`,
      border: `${COLORS.green}55`,
      text: COLORS.green,
    },
    error: {
      bg: `${COLORS.red}22`,
      border: `${COLORS.red}55`,
      text: COLORS.red,
    },
    info: {
      bg: '#ffffff10',
      border: COLORS.border,
      text: COLORS.text,
    },
  };

  const tone = palette[toast.type] || palette.info;
  const hasAction = typeof toast.onAction === 'function' && !!toast.actionLabel;

  const handleAction = () => {
    if (!hasAction) return;
    toast.onAction();
  };

  return (
    <div
      style={{
        position: 'fixed',
        right: '20px',
        bottom: '20px',
        zIndex: 1200,
        maxWidth: '420px',
        width: 'calc(100% - 40px)',
      }}
    >
      <div
        style={{
          background: tone.bg,
          border: `1px solid ${tone.border}`,
          color: tone.text,
          borderRadius: '14px',
          padding: '14px 16px',
          boxShadow: COLORS.shadow,
          backdropFilter: 'blur(10px)',
          display: 'flex',
          justifyContent: 'space-between',
          gap: '12px',
          alignItems: 'flex-start',
        }}
      >
        <div style={{ fontSize: '14px', lineHeight: 1.6 }}>
          <span>{toast.message}</span>
          {hasAction && (
            <>
              {' '}
              <button
                type="button"
                onClick={handleAction}
                style={{
                  background: 'transparent',
                  border: 'none',
                  color: COLORS.cyan,
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: 700,
                  lineHeight: 1.6,
                  padding: 0,
                  textDecoration: 'none',
                }}
              >
                {toast.actionLabel}
              </button>
            </>
          )}
        </div>
        <button
          type="button"
          onClick={onDismiss}
          style={{
            background: 'transparent',
            border: 'none',
            color: tone.text,
            cursor: 'pointer',
            fontSize: '16px',
            lineHeight: 1,
            padding: 0,
          }}
        >
          ×
        </button>
      </div>
    </div>
  );
}
